import React from 'react';
import { RefreshCw } from 'lucide-react';
export function ReturnsSection() {
  return <section className="bg-brand-light p-8 rounded-xl border border-gray-200" data-id="element-1046">
      <div className="flex items-start mb-6" data-id="element-1047">
        <RefreshCw className="h-8 w-8 text-brand-yellow mr-4 mt-1" data-id="element-1048" />
        <div data-id="element-1049">
          <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-1050">
            Return Policy
          </h2>
          <div className="prose text-gray-600" data-id="element-1051">
            <p className="mb-4" data-id="element-1052">
              If you are not satisfied with your purchase, you may return unused
              items in their original packaging within 30 days of delivery for a
              refund.
            </p>
            <p className="mb-4" data-id="element-1053">
              A 15% restocking fee applies to all returns. Shipping costs are
              non-refundable, and the customer is responsible for return
              shipping charges.
            </p>
            <p data-id="element-1054">
              Please contact our support team to obtain a Return Merchandise
              Authorization (RMA) number before shipping any items back.
            </p>
          </div>
        </div>
      </div>
    </section>;
}